// src/volumeRegistration/volumeRegistration.middleware.js

import { REGISTER_PRODUCT_BY_VOLUME } from './volumeRegistration.actions';
import actions from '../actions';
import service from './volumeRegistration.services';
import { I18n } from 'react-redux-i18n';

const volumeRegistrationMiddleware =
    ({ dispatch }) =>
    (next) =>
    (action) => {
        // Log every action to verify middleware is active
        console.log('[volumeMiddleware] saw action:', action.type);
        next(action);

        switch (action.type) {
            case REGISTER_PRODUCT_BY_VOLUME: {
                console.log('---------------------[volumeMiddleware] full action:', action);
                const body = createVolumeRegisterBody(action);

                console.log('[volumeMiddleware] REGISTER_PRODUCT_BY_VOLUME payload→', body);

                service
                    .registerProductByVolume(body)
                    .then((response) => {
                        dispatch(
                            actions.volumeRegistration.registerProductByVolumeResponse(response),
                        );
                        dispatch(actions.common.getVolumeContracts());
                        action.successCallback?.();
                    })
                    .catch((error) => {
                        const parsedError = parseVolumeRegistrationError(
                            error.response?.data || error,
                        );
                        dispatch(
                            actions.volumeRegistration.registerProductByVolumeError(parsedError),
                        );
                    });
                break;
            }

            default:
                // do nothing for other actions
                break;
        }
    };

const createVolumeRegisterBody = (action) => {
    return [
        ...action.traces.map((trace) => ({
            obra_social: action.os,
            contrato: action.contractId,
            traza: trace.trace,
            gtin: trace.gtin,
            serial_number: trace.sn,
            aplicacion: trace.cycle,
        })),
    ];
};

const parseVolumeRegistrationError = (error) => {
    console.log('🔍 Parsing error:', error);
    console.log('🔍 Error type:', typeof error);
    console.log('🔍 Error is array:', Array.isArray(error));

    // Handle string errors
    if (typeof error === 'string') {
        console.log('🔍 Returning string error:', error);
        return error;
    }

    // Handle backend error response format like [{"non_field_errors":["La traza ya fue registrada previamente"]}]
    if (Array.isArray(error) && error.length > 0) {
        console.log('🔍 Error is array, first element:', error[0]);
        const firstError = error[0];
        if (firstError.non_field_errors && Array.isArray(firstError.non_field_errors)) {
            console.log('🔍 Found non_field_errors:', firstError.non_field_errors[0]);
            return firstError.non_field_errors[0];
        }
    }

    // Handle object errors with non_field_errors
    if (error && typeof error === 'object') {
        console.log('🔍 Error is object, keys:', Object.keys(error));
        if (error.non_field_errors && Array.isArray(error.non_field_errors)) {
            console.log('🔍 Found non_field_errors in object:', error.non_field_errors[0]);
            return error.non_field_errors[0];
        }

        // Try to get the first error message from any key
        const firstErrorKey = Object.keys(error)[0];
        if (firstErrorKey && Array.isArray(error[firstErrorKey])) {
            console.log('🔍 Found error in key:', firstErrorKey, error[firstErrorKey][0]);
            return error[firstErrorKey][0];
        }
    }

    // Fallback to generic error
    const fallbackError = error?.message || I18n.t('errors.generic') || 'Unknown error';
    console.log('🔍 Using fallback error:', fallbackError);
    return fallbackError;
};

export default volumeRegistrationMiddleware;
